import React from "react"
import "./Officials.css"
import Navbar from "../../components/Homepage/Navbar/Navbar"
import Footer from "../../components/Homepage/Footer/Footer"
import officersData from "../../data/officers"

const Officials = () => {

  const {
    keyOfficials = [],
    principals = [],
    deans = [],
    directors = [],
    wardensAndCoordinators = []
  } = officersData || {}

  return (
    <div className="officials-page" id="officials-page-unique">
      <Navbar />

      <div className="officials-container" id="officials-container-unique">
        <div className="page-header" id="officials-page-header-unique">
          <h1>University Officials</h1>
          <div className="header-underline" />
        </div>

        <table className="officials-table" id="main-officials-table-unique">
          <thead>
            <tr>
              <th style={{ width: "60%" }}>Name</th>
              <th style={{ width: "40%" }}>Designation</th>
            </tr>
          </thead>

          <tbody>

            {/* KEY OFFICIALS */}
            {keyOfficials.map((official) => (
              <tr key={`key-${official.id}`}>
                <td>{official.name}</td>
                <td>{official.designation}</td>
              </tr>
            ))}

            {/* PRINCIPALS */}
            {principals.map((official) => (
              <tr key={`principal-${official.id}`}>
                <td>{official.name}</td>
                <td>{official.designation}</td>
              </tr>
            ))}

            {/* DEANS */}
            {deans.map((official) => (
              <tr key={`dean-${official.id}`}>
                <td>{official.name}</td>
                <td>{official.designation}</td>
              </tr>
            ))}

            {/* DIRECTORS */}
            {directors.map((official) => (
              <tr key={`director-${official.id}`}>
                <td>{official.name}</td>
                <td>{official.designation}</td>
              </tr>
            ))}

            {/* WARDENS & COORDINATORS */}
            {wardensAndCoordinators.map((official) => (
              <tr key={`warden-${official.id}`}>
                <td>{official.name}</td>
                <td>{official.designation}</td>
              </tr>
            ))}

          </tbody>
        </table>
      </div>

      <Footer />
    </div>
  )
}

export default Officials
